import { TEA_EVENT_NAME_MAPPING } from "../constants/cujEvents";
const teaEventNameFormatter = (name) => {
  return TEA_EVENT_NAME_MAPPING[name];
};
export {
  teaEventNameFormatter
};
